import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

interface TableBooleanFilterProps {
  value: string | undefined;
  onChange: (value: string) => void;
  disabled?: boolean;
}

export function TableBooleanFilter({ value, onChange, disabled = false }: TableBooleanFilterProps) {
  const handleToggle = (newValue: 'true' | 'false') => {
    if (value === newValue) {
      onChange('');
    } else {
      onChange(newValue);
    }
  };

  /* Patru stari, doua defecte, masurate pe ecran (nu calculate):

       stare              inainte   dupa
       inactiv, repaus      6,39     6,39
       inactiv, hover       4,36     5,68
       ACTIV, repaus        1,00     5,77
       ACTIV, hover         1,40     8,94

     1. Hover-ul inactiv vine din `variant="outline"`, care pune `--color-secondary`
        (se randeaza rgb(153,201,153)); textul `--color-dark` da 4,36, sub pragul de
        4,5 pentru text. `--color-light-hover` e tokenul facut exact pentru asta
        („slightly darker" fata de `--color-light`, care e chiar fundalul barei de
        filtre), deci hover-ul ramane vizibil fara sa scada contrastul.

     2. 🔴 Starea ACTIVA randa TEXT INVIZIBIL: contrast 1,00, culoarea textului egala
        cu fundalul. `@utility ecotic-boolean-filter-active` declara
        `background-color: var(--color-magenta)`, dar nu se aplica — se aplica doar
        `color: var(--color-light)`, iar fundalul ramanea cel transparent din
        `ecotic-boolean-filter`, prin care se vedea bara. Adica: nu se vedea CARE
        filtru e aplicat. Defect vechi, confirmat pe `main` curat inainte de orice
        schimbare a mea.
        Se repara prin clase Tailwind reale (`bg-magenta text-light`), care se aplica,
        in loc sa depindem de ordinea dintre doua `@utility`. `hover:text-light` e
        obligatoriu: fara el, `variant="outline"` readuce textul inchis la hover si
        contrastul cade la 1,40.

     Fixul sta AICI, nu in `main.css` sau `ui/button.tsx`: amandoua sunt fundatie, iar
     varianta `outline` se foloseste si in alte parti, cu alte perechi text/fundal. */
  return (
    <div className="relative flex flex-col">
      <div className="flex flex-row flex-nowrap justify-start space-x-2 pb-1">
        <Button
          type="button"
          variant="outline"
          size="sm"
          disabled={disabled}
          onClick={() => handleToggle('true')}
          className={cn(
            "ecotic-boolean-filter hover:bg-light-hover",
            value === 'true' && "ecotic-boolean-filter-active bg-magenta text-light hover:bg-magenta-hover hover:text-light"
          )}
        >
          DA
        </Button>
        <span className="self-center">/</span>
        <Button
          type="button"
          variant="outline"
          size="sm"
          disabled={disabled}
          onClick={() => handleToggle('false')}
          className={cn(
            "ecotic-boolean-filter hover:bg-light-hover",
            value === 'false' && "ecotic-boolean-filter-active bg-magenta text-light hover:bg-magenta-hover hover:text-light"
          )}
        >
          NU
        </Button>
      </div>
      <div className="h-px w-full rounded-full bg-dark" />
    </div>
  );
}

